import { get } from 'lodash-es';
import { createDate } from 'site-modules/shared/utils/date-utils';

export function isDiscontinuedDate(endDate) {
  return endDate && createDate() > createDate(endDate);
}

export function filterDiscontinuedStyles(styles) {
  return (
    styles &&
    styles.filter(style => {
      const endDate = get(style, 'attributeGroups.STYLE_INFO.properties.STYLE_END_DATE') || get(style, 'styleEndDate');

      if (!endDate) {
        return true;
      }

      return !isDiscontinuedDate(endDate);
    })
  );
}

/**
 * Finds submodels that match the styleId.  There could be two matches with different ruleType, for example tuner = STI Limited and body = Sedan
 * Since ruleType=tuner is the more detailed submodel and ruleType=body is more generic, tuner ruleType should have preference over body ruleType.
 * @param submodels
 * @param modelYear
 * @param makeSlug
 * @param modelSlug
 * @param year
 */
export const flattenAndNormalizeSubmodels = (submodels, modelYear, makeSlug, modelSlug, year) => {
  const flattened = submodels.flatMap(submodel =>
    (submodel?.styleList?.styles ?? []).map(style => ({
      ...style,
      id: Number(style.id), // Cast to number to mimic v4/styles/id={styleIds} response
      makeName: modelYear.makeName,
      makeNiceName: modelYear.makeSlug || makeSlug,
      modelName: modelYear.modelName,
      modelNiceName: modelYear.modelSlug || modelSlug,
      makeSlug: modelYear.makeSlug || makeSlug,
      modelSlug: modelYear.modelSlug || modelSlug,
      submodels: {
        name: submodel.internalName,
        slug: submodel.slug,
      },
      year: modelYear.year || parseInt(year, 10),
      ruleType: submodel.ruleType,
    }))
  );

  const stylesById = new Map();

  flattened.forEach(style => {
    const existingStyle = stylesById.get(style.id);

    if (!existingStyle || (style.ruleType === 'tuner' && existingStyle.ruleType !== 'tuner')) {
      stylesById.set(style.id, style);
    }
  });

  return [...stylesById.values()];
};
